// removed by extract-text-webpack-plugin
module.exports = {"maxTwoLines":"_2a_HCDkaGksyW2HsaBzpHn","card":"_3X-i1JzMfx5LntK_Nbj2fa","addCard":"_3x0q-KnkQ6Dw7fiXjYNk81","addIcon":"_2VIzLZN-dObfCp2NNjopDA","cardVideo":"_2FGLE3uceTd-Z94mPceWmO","contentVideo":"_2W8fZ4X1TBlm9AdkNEoNBB","actions":"_3U6BJ1ybGm1jaRJIPgG26Y","actionsInMobileView":"_2xiqSD7BmEiC1OyA2Ne3Ip","textOverflow":"_1Zn5pbfRnAzCkKEVKSdW6r","videoPlayWrapper":"e6W_Q1eTvdZEsa168neRJ","container":"_3avNOF2Wp69hNJL1inFFYz","videoActionMenu":"_1wtPuYNzEGvXFPIbmwL3Jg"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/playlists/form/videos/Videos.scss
// module id = 1649
// module chunks = 0